import React, { useEffect, useLayoutEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LoginForm from '@/components/auth/LoginForm';
import { useAuthStore } from '@/store/authStore';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, error } = useAuthStore();

  // Removed checkAuth call - it's already called in App.tsx to avoid duplicate calls

  // Restore service account error from sessionStorage synchronously before render
  // useLayoutEffect runs synchronously before the browser paints
  useLayoutEffect(() => {
    try {
      const savedError = sessionStorage.getItem('serviceAccountError');
      if (savedError) {
        const parsedError = JSON.parse(savedError);
        if (parsedError.code === 'SERVICE_ACCOUNT_NOT_ALLOWED') {
          // Restore error to store if not already set
          const storeError = useAuthStore.getState().error;
          if (!storeError || storeError.code !== 'SERVICE_ACCOUNT_NOT_ALLOWED') {
            useAuthStore.setState({
              error: parsedError,
              isAuthenticated: false,
              isLoading: false,
            });
            console.error('LoginPage: Restored service account error from sessionStorage:', parsedError);
          }
          // Clear from sessionStorage after restoring
          sessionStorage.removeItem('serviceAccountError');
        }
      }
    } catch (e) {
      console.warn('LoginPage: Failed to restore error from sessionStorage:', e);
    }
  }, []); // Only run once on mount

  useEffect(() => {
    // Log service account errors for debugging
    const currentError = useAuthStore.getState().error;
    if (currentError?.code === 'SERVICE_ACCOUNT_NOT_ALLOWED') {
      console.error('LoginPage: Service account login attempt detected:', currentError);
    }
    
    // Redirect if already authenticated (but not if there's a service account error)
    if (isAuthenticated && currentError?.code !== 'SERVICE_ACCOUNT_NOT_ALLOWED') {
      const from = (location.state as { from?: { pathname: string } })?.from?.pathname || '/';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, location, error]);

  const handleLoginSuccess = () => {
    const from = (location.state as { from?: { pathname: string } })?.from?.pathname || '/';
    navigate(from, { replace: true });
  };

  return <LoginForm onSuccess={handleLoginSuccess} />;
};

export default LoginPage;
